const buttonStyle = {
    root: {
        borderRadius: '10px',
        border:'1px solid #489C8F',
        color: '#489C8F',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#daebe8', 
          },
    },
  };
  
  export default buttonStyle;